import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Globals } from '../globals';
import {UserService} from './user.service';
import {PatientCaseViewDataModel} from '../models/patient/patient-case-view-data.model';
import {DoctorDataModel} from '../models/doctors/doctor-data.model';

@Injectable({
  providedIn: 'root'
})
export class LandingPageService {
  constructor(private http: HttpClient, private globals: Globals, private userService: UserService) { }

  updateLandingPageAppointmentStatus(appointment4LPObj: any) {
    return this.http.post<any>('/api/landing/updateLandingPageAppointmentStatus', appointment4LPObj);
  }

  getAppointmentsForDoctorByDateRange(DoctorID: string, dateRange: string, localTodayDate: string ): Observable<any> {
    const method: string = 'landing-page-appointments-ops';
    const url = '/api/' + method + '/' + DoctorID + '/' + dateRange + '/' + localTodayDate;
    return this.http.get<any>(url,  UserService.authorizationHeaderObject);
  }

  getAppointmentsForDoctorByPaging(doctorId: string, pageSize: number, pageIndex: number): Observable<any> {
    const method: string = 'landing-page-appointments-ops-by-paging';
    const url = '/api/' + method + '/' + doctorId + '/' + pageSize + '/' + pageIndex;
    return this.http.get<any>(url,  UserService.authorizationHeaderObject);
  }

  getPatientsCases(PatientID: string): Observable<any> {
    let url: string;
    let method: string = 'PatientCases';
    url = environment.TDOurl + method + '/' + PatientID;
    return this.http.get<any>(url);
  }

  getPatientsCases4Landing(PatientID: string, refreshCache: boolean = true): Observable<PatientCaseViewDataModel[]> {
    if(PatientID == null || PatientID == undefined || PatientID == '' || PatientID == 'null'){
      return new Observable<PatientCaseViewDataModel[]>();

    }

    const method: string = 'patient-cases-landing';
    const url = '/api/' + method + '/' + PatientID + '?t=' + (refreshCache ? Date.now() : '0');
    return this.http.get<PatientCaseViewDataModel[]>(url, UserService.authorizationHeaderObject);
  }
}
